export default {"src":"/_next/static/media/blueberries.04706f76.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};